type HeartbeatState = {
	endHeartbeatUrl?: string;
	gameSessionId?: string;
	heartbeatIntervalID?: NodeJS.Timeout | void;
};

const heartbeatState: HeartbeatState = {};
const getHeartbeatState = () => heartbeatState;

const tabCloseHandler = () => {
	if (navigator.sendBeacon && heartbeatState.endHeartbeatUrl) navigator.sendBeacon(heartbeatState.endHeartbeatUrl);
};

const startHeartbeat = (
	gameSessionId: string | undefined,
	heartbeatEndpoint: string,
	endHeartbeatEndpoint: string,
	interval: number
) => {
	heartbeatState.heartbeatIntervalID = setInterval(() => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		fetch(heartbeatEndpoint, {
			method: 'POST',
			body: heartbeatState.gameSessionId
		});
	}, interval);
	heartbeatState.gameSessionId = gameSessionId;
	heartbeatState.endHeartbeatUrl = endHeartbeatEndpoint;
	document.addEventListener('beforeunload', tabCloseHandler);
};

const stopHeartbeat = () => {
	if (heartbeatState.heartbeatIntervalID) {
		heartbeatState.heartbeatIntervalID = clearInterval(heartbeatState.heartbeatIntervalID);
		if (heartbeatState.endHeartbeatUrl) {
			if (navigator.sendBeacon) {
				navigator.sendBeacon(heartbeatState.endHeartbeatUrl, heartbeatState.gameSessionId);
			} else {
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				fetch(heartbeatState.endHeartbeatUrl, {
					method: 'POST',
					body: heartbeatState.gameSessionId
				});
			}
		}

		document.removeEventListener('beforeunload', tabCloseHandler);
	}
};

export { stopHeartbeat, startHeartbeat, tabCloseHandler, getHeartbeatState };
